import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';
import { useRouteMatch } from 'react-router';

import { StorageHandler, DataHandler } from 'C4';
import { defaultAppId, imgixUrl, storageKeys } from 'settings';

import appContent from 'helpers/appContent';
import { faCreativeCommonsSamplingPlus } from '@fortawesome/free-brands-svg-icons';

const BackImage = ({ blur, darken, background }) =>
  background && (
    <div style={{ backgroundImage: `url("${background}")` }} className={clsx('backgroundImage', { blur, darken })} />
  );

const BackVideo = ({ background }) => {
  const [fallback, setFallback] = useState(null);
  const [ready, setReady] = useState(false);
  const [poster, setPoster] = useState(null);

  useEffect(() => {
    const src = `${background}.jpg`;

    const img = new Image();
    img.onload = () => setPoster(src);
    img.onerror = () => setPoster(`${background}.jpg`);
    img.src = src;
  }, [background]);

  return (
    <React.Fragment>
      {fallback && <Background type="image" background={fallback} />}
      {fallback === null && poster && (
        <video
          className="backgroundVideo"
          src={`${background}`}
          autoPlay
          muted
          loop
          preload="auto"
          poster={poster}
          onError={() => {
            // if (fallback === null) setFallback(`${background}.jpg`);
          }}
          onLoadedData={() => {
            if (!ready) setReady(true);
          }}
          style={{ opacity: +ready }}
        >
          <track kind="captions" />
        </video>
      )}
    </React.Fragment>
  );
};

const components = {
  image: BackImage,
  video: BackVideo,
};

const Background = ({ type, background: defaultBackground, className, ...props }) => {
  const { path } = useRouteMatch();

  const [background, setBackground] = useState(defaultBackground);

  const Component = components[type];

  useEffect(() => {
    if (type === 'video') {
      let videoUrl = appContent('bgVideo.mp4');
      if (background) {
        videoUrl = background;
      }
      setBackground(videoUrl);
    }
    if (type === 'image' && background === null) {
      const img = new Image();
      const appInfo = StorageHandler.load(storageKeys.appInfo);
      if (appInfo.background && appInfo.background !== '') {
        img.src = `${appContentUrl}${DataHandler.matchAppIdSync()}/bg@2x.jpg`;
        img.onload = () => setBackground(img.src);
      } else {
        img.src = `${appContentUrl}${DataHandler.matchAppIdSync()}/bg@2x.jpg`;
        img.onload = () => setBackground(img.src);
      }
    }
  }, [path, type, background]);

  return (
    background && (
      <div className={clsx('wrapper__background', className)}>
        <Component background={background} {...props} />
      </div>
    )
  );
};

export default Background;

Background.propTypes = {
  type: PropTypes.string,
  darken: PropTypes.bool,
  blur: PropTypes.bool,
  background: PropTypes.string,
};

Background.defaultProps = {
  type: 'image',
  darken: false,
  blur: false,
  background: null,
};

BackImage.propTypes = Background.propTypes;
BackImage.defaultProps = Background.defaultProps;

BackVideo.propTypes = Background.propTypes;
BackVideo.defaultProps = Background.defaultProps;
